/* eslint-disable no-useless-escape */
import React, { useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";
import moment from "moment";
import Linkify from "react-linkify";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import {
  liveAgentChatSagaAction,
  chatpatient,
  liveAgentChatCountAction,
  chatMessageSagaAction,
} from "../../../../sagas/saga-actions";
import { openChatByAgent } from "../../../../sagas/saga-claimChat";
import { shiftPatientTopSagaAction } from "../../../../sagas/saga-actions";
import loginService from "../../../../service/login";
import { urls, AGENT_TYPING } from "../../../../constants/constants";
import { getStandardTime } from "../../../../helper/helpers";
import {
  CheckIcon,
  FailedIcon,
  SMSIcon,
  IVRIcon,
} from "../../../../assets/svg";
import "./chat.scss";
import ChatInner from "./chatInner";
import { updateMessageStatusSagaAction } from "../../../../sagas/saga-loadChat";

const obj = {
  userId: 1,
  patientId: 1,
  messageBody: "hi",
  conversationType: "outbound",
  msgType: "conversation",
  senderNo: loginService.getTextingNumber(),
  practiceId: "",
  ehr: "",
};

const agentStatusIcon = {
  delivered: <CheckIcon success />,
  sent: <CheckIcon />,
  failed: FailedIcon,
};

const Chat = (props) => {
  const {
    user,
    activeChatPatientNumber,
    history,
    liveAgentChatSaga,
    patients,
    liveAgentChat,
    Sound,
    liveAgentChatCount,
    handleAgentChat,
  } = props;

  const [state, setState] = useState({
    messages: [],
    value: "",
    checkingProps: "",
    hasMore: true,
    goBottom: false,
    chatUpdated: false,
    currentUser: "",
    page: 0,
    allowTyping: true,
    claimChatPopup: false,
    uploadLink: null,
  });

  const textInputRef = React.useRef();
  const sendMessageRef = React.useRef();
  const scrollRef = React.useRef();
  const patientIdRef = React.useRef();

  const isEmpty = (o) => {
    return !(o && Object.keys(o).length);
  };

  function isValidJSON(jsonString) {
    try {
      const o = JSON.parse(jsonString);

      // Handle non-exception-throwing cases:
      // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
      // but... JSON.parse(null) returns null, and typeof null === "object",
      // so we must check for that, too. Thankfully, null is falsey, so this suffices:
      if (o && typeof o === "object") {
        return o;
      }
    } catch {
      return false;
    }
    return false;
  }

  const renderJSON = (obj) => {
    const data = obj.payload;
    // eslint-disable-next-line default-case
    if (obj.type === "AGENT_USER_DETAILS_BODY") {
      return (
        <div>
          User's details: <br />
          Name: {data.firstName} {data.lastName} <br />
          Email: {data.email} <br />
          Mobile: {data.cellPhone} <br />
        </div>
      );
    }
  };

  // update message status
  const updateSentMessageStatus = useCallback(({ msg }) => {
    if (msg) {
      const { messages } = state;
      if (messages.length && messages.filter((e) => e.id === msg.id).length) {
        setState((st) => {
          const newMessages = st.messages.map((message) => {
            if (message.patient) {
              if (
                message.patient.id === msg.patientId &&
                message.id === msg.id
              ) {
                message.messageStatus = msg.messageStatus;
              }
            } else {
              if (
                message.patientId === msg.patientId &&
                message.id === msg.id
              ) {
                message.messageStatus = msg.messageStatus;
              }
            }

            return message;
          });
          return {
            ...st,
            messages: [...newMessages],
          };
        });
        scrollToBottom();
      } else {
        if (
          msg.userId === props.user.id &&
          activeChatPatientNumber === msg.recipientNo
        ) {
          setState((st) => ({
            ...st,
            messages: [...st.messages, msg],
          }));
          scrollToBottom();
        }
      }
    }
  }, []);

  useEffect(() => {
    const token = loginService.getToken();
    if (!token) {
      history.push("/login");
    }
    localStorage.removeItem("ehr");

    // socket event listener for socket service
    window.addEventListener(
      "addLiveAgentSentMessageToState",
      (e) => {
        addLiveAgentSentMessageToState(e.detail);
      },
      false
    );

    // socket event listener for socket service
    window.addEventListener(
      "lcAgentReceiveMsg",
      (e) => {
        lcAgentReceiveMsg(e.detail);
      },
      false
    );

    // socket event listener for socket service
    window.addEventListener(
      "updateSentMessageStatusForLiveAgent",
      (e) => {
        updateSentMessageStatus(e.detail);
      },
      false
    );
    return () => {
      window.removeEventListener(
        "addLiveAgentSentMessageToState",
        addLiveAgentSentMessageToState
      );
      window.removeEventListener("lcAgentReceiveMsg", lcAgentReceiveMsg);
      window.removeEventListener(
        "updateSentMessageStatusForLiveAgent",
        updateSentMessageStatus
      );
    };
  }, []);

  const updatePatientList = (user, msg) => {
    let tab = localStorage.getItem("tabSetAgent");

    if ((tab = "activeChat")) {
      tab = 1;
    } else if ((tab = "unClaimedChat")) {
      tab = 0;
    } else {
      tab = 2;
    }

    scrollToBottom();
    if (user && user.id) {
      const sidenav = {
        offset: 0,
        active: tab,
      };
      liveAgentChatSaga(sidenav);
    }
  };

  const getNewChat = () => {
    const { patient } = patients;
    const currentChatUser = patient || {};
    const activeList = liveAgentChat.chatList || [];
    const currentValue = activeList.length
      ? activeList.filter((user, index) => user.id === currentChatUser.id)
      : [];
    if (
      currentValue &&
      currentValue[0] &&
      currentValue[0].id !== state.currentUser
    ) {
      setState((st) => ({
        ...st,
        messages: [],
        chatUpdated: false,
        hasMore: true,
        currentUser: currentValue[0].id,
        page: 0,
      }));
    } else {
      return null;
    }
  };

  useEffect(
    () => {
      patientIdRef.current = patients.patient.id;
      getNewChat();
    },
    [patients.patient.id]
  );

  const handleChange = (e) => {
    e.persist();
    setState((st) => ({
      ...st,
      postVal: e.target.value,
      value: e.target.value,
    }));
  };

  const sendAgentTypingMessage = () => {
    // eslint-disable-next-line
    const activeArrayList = liveAgentChat?.chatList
      ? liveAgentChat.chatList
      : [];
    const currentChatUser = patients?.patient ? patients.patient : {};

    const currentValue = activeArrayList.filter(
      (patient, index) => patient.id === currentChatUser.id
    );
    if (!currentValue[0]) {
      return;
    }

    obj.to = currentValue[0].email;
    const ehrName =
      user && user.practice && user.practice.ehrName
        ? user.practice.ehrName.toLowerCase()
        : "";
    obj.from = loginService.getTextingNumber();
    obj.ehr = ehrName;

    let message = {
      ...obj,
      messageBody: AGENT_TYPING,
      clientId: patients.patient.id,
      userId: user.id,
      practiceId: user.practiceId,
    };

    const sendMessage = new CustomEvent("lcAgentSendMessage", {
      detail: { message },
    });
    window.dispatchEvent(sendMessage);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // eslint-disable-next-line
    let value = `${state.value.replace(
      /[^A-Za-z0-9 \r\n@£$¥èéùìòÇØøÅå\x{0394}_\x{03A6}\x{0393}\x{039B}\x{03A9}\x{03A0}\x{03A8}\x{03A3}\x{0398}\x{039E}ÆæßÉ!\"#$%&\'\(\)*+,\-.\/:;<=>;?¡ÄÖÑÜ§¿äöñüà^{}\[\~\]\|\x{20AC}\\]*/gi,
      ""
    )} ${state.uploadLink ? state.uploadLink : ""}`;
    if (!value.trim().length) return;

    const activeArrayList =
      liveAgentChat && liveAgentChat.chatList ? liveAgentChat.chatList : [];
    const currentChatUser =
      patients && patients.patient ? patients.patient : {};

    if (value !== "") {
      const currentValue = activeArrayList.filter(
        (patient, index) => patient.id === currentChatUser.id
      );
      if (!currentValue[0]) {
        return;
      }

      obj.to = currentValue[0].email;
      let ehrName =
        user && user.practice && user.practice.ehrName
          ? user.practice.ehrName.toLowerCase()
          : "";
      obj.from = loginService.getTextingNumber();
      obj.ehr = ehrName;

      let message = {
        ...obj,
        messageBody: value,
        clientId: patients.patient.id,
        userId: user.id,
        practiceId: user.practiceId,
      };

      if (!sendMessageRef.current) {
        sendMessageRef.current = true;
        const sendMessage = new CustomEvent("lcAgentSendMessage", {
          detail: { message },
        });
        window.dispatchEvent(sendMessage);
        setState((st) => ({
          ...st,
          page: 0,
          loadMore: false,
        }));
        sendMessageRef.current = false;
        if (textInputRef?.current) {
          textInputRef.current.focus();
        }
      }
    }
  };

  // receive message from Socket service
  const addLiveAgentSentMessageToState = ({ data }) => {
    if (data.messageBody.startsWith(AGENT_TYPING) === false) {
      Sound.send();
      if (!data.messageStatus) {
        data.messageStatus = undefined;
      }

      setState((st) => ({
        ...st,
        messages: [...st.messages, data],
        value: "",
        uploadLink: null,
      }));
      sendMessageRef.current = false;
    }
    scrollToBottom();
  };

  // receive message status from Socket service
  const lcAgentReceiveMsg = ({ msg }) => {
    if (msg.messageBody.startsWith(AGENT_TYPING)) return;

    if (msg !== null && msg !== "sent" && msg !== "delivered") {
      const { messages } = state;
      const { patient } = patients;
      // avoid adding the message sent by the user in the same chat window
      if (msg.userId === user.id) {
        let exists = false;
        messages.forEach((item) => {
          if (item.id === msg.id) {
            exists = true;
            return;
          }
        });
        if (exists) {
          return;
        } else if (msg.sendLinkMessage) {
          const currentEhrName =
            user && user.practice && user.practice.ehrName
              ? user.practice.ehrName.toLowerCase()
              : "";

          obj.senderNo = loginService.getTextingNumber();

          obj.ehr = currentEhrName;

          const newMessage = {
            ...obj,
            messageBody: msg.messageBody,
            conversationType: msg?.conversationType,
            patientId: msg.patientId,
            senderNo: msg.senderNo,
            recipientNo: msg.recipientNo,
            user: msg.user,
            id: msg.id,
          };

          messages.push(newMessage);

          const currentChatUser = patient || {};
          const activeList = liveAgentChat.chatList || [];
          const currentValue = activeList.length
            ? activeList.filter((user, index) => user.id === currentChatUser.id)
            : [];

          const finalState = {
            page: 0,
            loadMore: false,
            messages: [...messages],
            value: "",
          };

          if (
            currentValue &&
            currentValue[0] &&
            currentValue[0].id !== state.currentUser
          ) {
            finalState.currentUser = currentValue[0].id;
          }

          setState((st) => ({
            ...st,
            finalState,
          }));

          getNewChat();
          scrollToBottom();

          return;
        }
      }
      // eslint-disable-next-line
      let id = "";
      liveAgentChatCount();

      if (isEmpty(patient) === false) {
        id = patient.id;
      }
      let ehrName =
        user && user.practice && user.practice.ehrName
          ? user.practice.ehrName.toLowerCase()
          : "";
      obj.senderNo = loginService.getTextingNumber();
      obj.ehr = ehrName;
      let message = {
        ...obj,
        messageBody: msg.messageBody,
        conversationType: msg?.conversationType,
        patientId: msg.clientId,
        senderNo: msg.senderNo,
        recipientNo: msg.recipientNo,
        user: msg.user,
        id: msg.id,
      };

      if (
        patients &&
        patients.patient &&
        patientIdRef.current === message.patientId &&
        loginService.isLoggedin()
      ) {
        if (loginService.isLoggedin()) {
          if (msg?.conversationType === "inbound") Sound.receive();
          else Sound.send();
        }

        // eslint-disable-next-line no-unused-vars
        const _finalState = {
          page: 0,
          loadMore: false,
          messages: [...messages],
          value: "",
        };

        messages.push(message);

        setState((st) => ({
          ...st,
          page: 0,
          loadMore: false,
          messages: [...st.messages, message],
        }));

        // eslint-disable-next-line no-unused-vars
        const currentObject = {
          userId: user.id,
          messageId: msg.id,
        };

        updatePatientList(user, msg);
      } else {
        updatePatientList(user, msg);
      }
    }
  };

  const claimChat = (data) => {
    props.openChatByAgent(data, () => {
      props.liveAgentChatCount();
      const event = new Event("refreshCurrentAgentTab");
      window.dispatchEvent(event);
      props.chatPatient({});
    });
  };

  const loadMore = () => {
    let { page } = state;
    const { patient } = patients;
    const patientId = patient && patient.id;
    if (!patientId) {
      setState((st) => ({
        ...st,
        hasMore: false,
        page: page + 1,
      }));
    } else if (page >= 0) {
      const { messages } = state;
      fetch(
        `${
          urls.aspariaBackend
        }api/v1/livechat-agent/getConversation?pageNo=${page +
          1}&pageSize=15&clientId=${patientId}`,
        {
          headers: {
            method: "GET",
            accept: "application/json",
            Authorization: `Bearer `,
            Pragma: "no-cache",
          },
          credentials: "include",
        }
      )
        .then((data) => {
          return data.json();
        })
        .then((result) => {
          if (result && result.length > 0) {
            let newMessages = [...result.reverse(), ...messages];
            setState((st) => ({
              ...st,
              messages: newMessages,
              page: page + 1,
            }));
          } else {
            setState((st) => ({
              ...st,
              hasMore: false,
              page: page + 1,
            }));
          }
        });
    }
  };

  const getMessageItemClassName = (message, index) => {
    const last = state.messages.length - 1;
    let convo = message?.conversationType || "inbound";
    let messages = state.messages;
    let className;

    if (convo === "inbound") className = "sent";
    else className = "replies";

    let prev = "",
      next = "";
    if (index > 0) prev = messages[index - 1]?.conversationType || "inbound";
    if (index > 0 && index < last)
      next = messages[index + 1]?.conversationType || "inbound";

    if (index === 0) return `${className} ${className}-top`;
    else if (prev && convo !== prev) return `${className} ${className}-top`;
    else if (prev && convo === prev && next && convo === next)
      return `${className} ${className}-middle`;
    else if (prev && convo === prev) return `${className} ${className}-last`;
    else if (index === last) return `${className} ${className}-top`;

    return `${className} ${className}-top`;
  };

  const getConversationStatus = (messageStatus) => {
    if (
      !messageStatus ||
      messageStatus === "queued" ||
      messageStatus === "sent"
    ) {
      return "sent";
    }
    if (!messageStatus || messageStatus === "delivered") {
      return "delivered";
    } else if (messageStatus === "failed") {
      return "failed";
    }
    return messageStatus;
  };

  const getMessageCaption = (message, index) => {
    let caption;
    const convo = message?.conversationType || "inbound";

    const messageStatus =
      convo === "outbound" ? getConversationStatus(message.messageStatus) : "";
    const temp =
      message && message.createdAt ? new Date(message.createdAt) : new Date();
    const hh = temp.getHours();
    const min = temp.getMinutes();
    const format = `${hh < 10 ? "0" : ""}${hh}:${min < 10 ? "0" : ""}${min}`;
    const time = getStandardTime(format);
    const broadCastInfo =
      convo === "outbound" && message.msgType === "broadcast" ? (
        <>
          <span className="broadcast-info">
            {message.convoType === "ivr" ? IVRIcon : SMSIcon} Broadcast Message{" "}
            <span className="separator">-</span>
          </span>
        </>
      ) : (
        ""
      );
    caption = (
      <>
        {broadCastInfo}
        {time}{" "}
        {messageStatus && (
          <>
            <span className="divider large" />
            <span className={`status ${messageStatus}`}>
              {messageStatus}{" "}
              <span className="status-icon">
                {agentStatusIcon[messageStatus] || <CheckIcon />}
              </span>
            </span>
          </>
        )}
      </>
    );

    return caption ? <span className="caption">{caption}</span> : null;
  };

  const scrollToBottom = () => {
    if (scrollRef && scrollRef.current) {
      scrollRef.current.scrollIntoView();
    }
  };

  const displayChat = () => {
    const { messages } = state;

    const dates = [];

    const partition = (date) => {
      let displayDate = date;
      const yesterday = moment().subtract(1, "day");

      if (moment().isSame(moment(displayDate), "day")) {
        displayDate = "Today";
      } else if (yesterday.isSame(moment(displayDate), "day")) {
        displayDate = "Yesterday";
      } else {
        displayDate = moment(date).format("dddd MMMM DD, YYYY");
      }

      return (
        <div key={displayDate} className="chat-date-partition">
          <p>{displayDate}</p>
        </div>
      );
    };
    const chatComponent = (message, index) => (
      <li
        key={message.id}
        className={`message-container ${getMessageItemClassName(
          message,
          index
        )}`}
      >
        <div
          className={`chat-msg ${
            message?.conversationType === "outbound" ? "outgoing" : "received"
          }
          `}
        >
          <p className="message-box">
            <Linkify
              componentDecorator={(decoratedHref, decoratedText, key) =>
                /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z0-9]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/.test(
                  decoratedText
                ) ? (
                  <a target="blank" href={decoratedHref} key={key}>
                    {decoratedText}
                  </a>
                ) : (
                  decoratedText
                )
              }
            >
              {isValidJSON(message.messageBody)
                ? renderJSON(JSON.parse(message.messageBody))
                : message.messageBody}
            </Linkify>
          </p>
          {getMessageCaption(message, index)}
        </div>
      </li>
    );

    state.messages = Array.from(new Set(messages.map((a) => a.id))).map(
      (id) => {
        return messages.find((message) => message.id === id);
      }
    );

    return (
      <ul className="chat-messages-list">
        {state.messages &&
          state.messages
            .filter((msg) => {
              if (msg.messageBody.startsWith(AGENT_TYPING)) {
                return false;
              }
              return true;
            })
            .map((message, index) => {
              const element = [];
              if (
                message.createdAt &&
                !dates.includes(message.createdAt.slice(0, 10))
              ) {
                dates.push(message.createdAt.slice(0, 10));
                element.push(partition(message.createdAt.slice(0, 10)));
              }
              element.push(chatComponent(message, index));

              return element;
            })}

        <div ref={scrollRef} />
      </ul>
    );
  };

  const handleCancel = () => {
    setState((st) => ({ ...st, claimChatPopup: false }));
  };

  const handleChatInput = (e) => {
    setState((st) => ({
      ...st,
      allowTyping: false,
    }));
    handleSubmit(e);
    setTimeout(
      () =>
        setState((st) => ({
          ...st,
          allowTyping: true,
        })),
      2000
    );
  };

  const handleClaimButton = () => {
    setState((st) => ({ ...st, claimChatPopup: true }));
  };

  return (
    <ChatInner
      chatProps={props}
      chatState={state}
      handleSubmit={handleSubmit}
      textInputRef={textInputRef}
      handleChange={handleChange}
      sendMessageRef={sendMessageRef}
      claimChat={claimChat}
      sendAgentTypingMessage={sendAgentTypingMessage}
      handleCancel={handleCancel}
      handleChatInput={handleChatInput}
      handleClaimButton={handleClaimButton}
      loadMore={loadMore}
      displayChat={displayChat}
      handleAgentChat={handleAgentChat}
    />
  );
};

const mapStateToProps = (state) => ({
  patients: state.patients,
  //chat can be removed
  chat: state.chat,
  user: state.login.user,
  //loadChat can be removed
  loadChat: state.loadChat,
  liveAgentChat: state.liveAgentChat,
});

const mapDispatchToProps = (dispatch) => {
  return {
    chatMessageSagaAction: (chat) => {
      dispatch(chatMessageSagaAction(chat));
    },
    openChatByAgent: (data, cb) => {
      dispatch(openChatByAgent(data, cb));
    },
    liveAgentChatSaga: (data) => dispatch(liveAgentChatSagaAction(data)),
    chatPatient: (data) => {
      dispatch(chatpatient(data));
    },
    shiftPatientTopSagaAction: (data) => {
      dispatch(shiftPatientTopSagaAction(data));
    },
    updateMessageStatusSagaAction: (data) => {
      dispatch(updateMessageStatusSagaAction(data));
    },
    liveAgentChatCount: () => dispatch(liveAgentChatCountAction()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Chat);
